import { createAction } from '@reduxjs/toolkit';

import type { Language } from 'config/enums';

export interface ReturnToQueuePayload {
  gender: string;
  language: Language;
}

export const returnToQueueCleanupStarted = createAction(
  'returnToQueue/cleanupStarted'
);

export const returnToQueueCleanupFailed = createAction(
  'returnToQueue/cleanupFailed'
);
